// Briefs: a project's Monday brief (V4MondayBrief) and a brand's seven-section
// brief (V4Brief).
export default {
  lundi: {
    titre: 'Monday brief',
    erreur: 'Could not load the brief',
    // A quoted line, with the language's quotation marks.
    citation: '“{texte}”',
    choisir: 'Choose a project',
    enCours: '(in progress)',
    semaine: {
      courante: 'This week (in progress)',
      du: 'Week of {debut} to {fin}',
      courte: 'Week of {date}',
      sorties: '{semaine} · {n}',
      vide: '{semaine} · empty',
      precedente: 'Previous week',
      suivante: 'Next week',
    },
    mouvement: {
      nouveau: 'new',
      monte: 'rising',
      stable: 'holding',
      recule: 'falling',
    },
    sansDossier: 'The Monday brief is read per project: choose one in the left sidebar. It brings together what Orion’s patrol saw on its territories and what its brands’ twins reported.',
    legende: {
      patrouille: 'Orion’s patrol',
      arene: 'Arena',
      grille: 'Grid',
    },
    recalculerAide: 'Recompute the brands’ readout for this week',
    recalculer: 'recompute',
    rassemblement: 'Gathering the week…',
    essentiel: 'The week at a glance',
    territoires: {
      titre: 'Your territories, as Orion sees them',
      sousTitre: 'where their audience heads of its own accord',
      aucun: 'No territories yet: they come up from the brands as soon as an audit detects them.',
      principal: 'main',
      aucuneSortie: 'no runs this week',
      rienQuiSeDetache: 'nothing stands out',
      eclaireurs: '{n} scouts',
      monteAussi: 'also rising',
      tient: 'holding',
      recule: 'falling',
      devraitMonter: 'should keep rising',
      projete: 'Level projected in seven days at the current pace: {avant} → {apres}, confidence {pct}%',
      revoir: 'A topic has to be seen again over several days to count.',
    },
    traverse: {
      titre: 'What runs across your territories',
      reduire: 'show less',
      voirTout: 'see all {n}',
    },
    marque: {
      vu: 'what its twins saw',
      carte: 'the twins map →',
      aucuneFlotte: 'No fleet went out this week: without the Arena, we cannot tell where the brand stands, so not where it is missing either.',
      activer: 'Activate the project’s twins →',
      pasSortie: 'did not go out',
      sorties: '{n} runs | {n} run | {n} runs',
      percu: 'perceived vs expected',
      espacesBlancs: 'white spaces · to settle at the Research desk',
      jours: '{n} days · {ou}',
      demande: 'Should {marque} speak up on “{sujet}”? Its audience has been going there for {jours} days, and the brand is not there.',
      tester: 'test →',
      masquerMots: 'hide their words',
      voirMots: 'what is rising among its twins, in their own words ({n})',
      isos: '· {isos} twins, {terr} terr.',
      cliquent: 'they click for',
      lasse: 'wearing thin',
    },
    predictions: {
      titre: 'Projections',
      aVenir: 'Coming up · 4 weeks',
      aucunRendezVous: 'No dated event with a simulation in the project’s field. A country’s general news is not included.',
      simulation: 'simulation:',
      aRelire: 'To review · the day has passed',
      aRelireTexte: 'A dated simulation whose actual outcome nobody has recorded. Checking it against reality is how we know what the instrument is worth.',
      rienEnAttente: 'Nothing pending.',
      lectures: 'Simulations run on the rising topics',
    },
    decisions: {
      titre: 'Open decisions',
      registre: '{n} register projections awaiting their outcome | {n} register projection awaiting its outcome | {n} register projections awaiting their outcome',
      plusieursMarques: 'several brands',
    },
    bureau: {
      titre: 'To open at the Research desk',
      ouvrir: 'Open a study',
    },
    pied: 'Everything is counted from what the twins reported, Orion’s and the brand’s: synthetic individuals calibrated on measured audiences. None of it is written by a model, and the territories’ synthesis is not included.',
  },

  // ── A brand's seven-section brief ─────────────────────────────────────────
  sept: {
    titre: 'Brief',
    titreTerritoire: 'Brief - {territoire}',
    sousTitre: '{marque} · 7 sections',
    erreur: {
      generation: 'Could not generate',
      blast: 'Could not send to BLAST',
    },
    production: {
      concept: 'Concept',
      format: 'Format',
      angle: 'Angle',
      ton: 'Tone',
      timing: 'Timing',
    },
    territoire: {
      position: 'position on the map',
      espaceLibre: 'white space',
      recouvrement: 'overlap',
    },
    persona: {
      part: 'share {n}%',
      confiance: 'confidence {n}%',
    },
    dashboard: 'Dashboard',
    verrouillee: 'Locked structure ·',
    recentes: 'recent data',
    aideRegenerer: 'Regenerates the brief from the latest audit',
    aideGenerer: 'Generates the brief from the white space, the personas and the brand score',
    generation: 'Generating…',
    regenerer: 'Regenerate',
    generer: 'Generate the brief',
    aideBlast: 'Creates a BLAST campaign with a single-variable test plan derived from this brief',
    creation: 'Creating…',
    envoyerBlast: 'Send to BLAST',
    chargement: 'Loading…',
    aucun: 'No brief for this brand',
    aucunTexte: 'The brief is built on the detected territory (white space), the personas and the Brand Strength Score. Run a full analysis first if you have not already, then generate.',
    section: {
      decision: 'The decision',
      signal: 'Signal',
      territoire: 'Territory',
      persona: 'Persona validation',
      production: 'What we produce',
      gardeFous: 'Guardrails',
      mesure: 'How we measure',
    },
    signal: {
      territoire: 'territory',
      force: 'strength (white space score)',
      velocite: 'velocity / 30 d',
    },
    voirCarte: 'see on the map →',
    core: 'Core',
    emerging: 'Emerging target',
    aValider: 'to validate',
    kanban: 'See the kanban',
  },
}
